<div
  class="tw-b-co tw-sticky tw-top-0 tw-z-40 tw-flex tw-h-16 tw-items-center tw-justify-between tw-border-b tw-border-neutral-300 tw-bg-white tw-px-4"
>
  <h1 id="drawer-title" class="tw-text-base" tabindex="-1">
    {{ drawer().title }}
  </h1>

  @if (!drawer().disableClose) {
    <button
      type="button"
      class="tw-btn-medium tw-btn-icon tw-btn-ghost-neutral"
      (click)="drawerClose()"
    >
      <da-icon icon="x-mark" type="solid" [solidSize]="20" class="tw-size-6" />
      <span class="tw-sr-only">{{ i18n.Core_Close }}</span>
    </button>
  }
</div>
